import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RFFConstants } from '../constants';
@Component({
  selector: 'app-pdf-image-preview',
  templateUrl: './pdf-image-preview.component.html',
  styleUrls: ['./pdf-image-preview.component.scss']
})
export class PdfImagePreviewComponent implements OnInit {
  @Input() pdfPreview;
  @Input() fieldType;
  formPreviewField;
  constructor(
    public activeModal: NgbActiveModal,
    private _rffConstants: RFFConstants
  ) {}

  ngOnInit() {
    if(this.pdfPreview.type == undefined){
      document.querySelector("iframe").src = 'data:application/pdf;base64,' + this.pdfPreview.pdf
    } else {
      if(this.pdfPreview.type != "UPLOAD") {
        document.querySelector("iframe").src = this.pdfPreview.url;
      } else {
        document.querySelector("iframe").src = 'data:application/pdf;base64,' + this.pdfPreview.pdf
      }
    }
  }
  close(){
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/pdf-image-preview/pdf-image-preview.component.ts